import { message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  initialBrandingState,
  initialGradientStart,
  initialGradientEnd,
} from "../../const";
import { parseGradient } from "../parseGradient";
import { validateImageFiles } from "../../../../../utils/validateImageFiles";

export const useBranding = () => {
  const [branding, setBranding] = useState(initialBrandingState);
  const [gradientStart, setGradientStart] = useState(initialGradientStart);
  const [gradientEnd, setGradientEnd] = useState(initialGradientEnd);
  const [imageFiles, setImageFiles] = useState([]);

  useEffect(() => {
    const gradientString = `linear-gradient(135deg, rgba(${parseInt(
      gradientStart.color.slice(1, 3),
      16
    )}, ${parseInt(gradientStart.color.slice(3, 5), 16)}, ${parseInt(
      gradientStart.color.slice(5),
      16
    )}, ${gradientStart.opacity}), rgba(${parseInt(
      gradientEnd.color.slice(1, 3),
      16
    )}, ${parseInt(gradientEnd.color.slice(3, 5), 16)}, ${parseInt(
      gradientEnd.color.slice(5),
      16
    )}, ${gradientEnd.opacity}))`;
    setBranding((prev) => ({ ...prev, searchBarGradient: gradientString }));
  }, [gradientStart, gradientEnd]);

  const fetchBranding = async () => {
    try {
      const response = await axios.get(`/api/branding/getallbranding`);
      const data = response.data || initialBrandingState;
      setBranding(data);

      // Parse the gradient colors and opacities
      const parsedGradient = parseGradient(data.searchBarGradient);
      setGradientStart(parsedGradient.start);
      setGradientEnd(parsedGradient.end);
    } catch (error) {
      console.error("Error fetching branding settings:", error);
      message.error("Failed to fetch branding settings.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBranding((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setImageFiles(e.target.files);
    const file = e.target.files[0];
    setBranding((prev) => ({
      ...prev,
      pageBackgroundImageFile: file,
      pageBackgroundImage: URL.createObjectURL(file),
    }));
  };

  const handleSave = async () => {
    try {
      if (Array.isArray(imageFiles) && imageFiles.length > 0) {
        const isErrorImage = validateImageFiles({ files: imageFiles });
        if (isErrorImage) {
          Swal.fire({
            title: "Error",
            text: isErrorImage,
            icon: "error",
          });
          return;
        }
      }
      const formData = new FormData();
      Object.keys(branding).forEach((key) => {
        if (key !== "pageBackgroundImageFile") {
          formData.append(key, branding[key]);
        }
      });

      if (branding.pageBackgroundImageFile) {
        formData.append("backgroundImage", branding.pageBackgroundImageFile);
      }

      const response = await axios.post("/api/branding/create", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setBranding(response.data);
      message.success("Branding settings saved successfully!");
    } catch (error) {
      console.error("Error saving branding settings:", error);
      message.error("Failed to save branding settings.");
    }
  };

  return {
    fetchBranding,
    branding,
    gradientStart,
    gradientEnd,
    handleInputChange,
    handleFileChange,
    handleSave,
    setGradientStart,
    setGradientEnd,
  };
};
